export default __webpack_public_path__ + "static/media/linkedin-2.3608ee13.svg";